import React from 'react';
import { alertError, alertSuccess } from '../config/toast';
import { getadminReq, rmadminReq, addadminReq, updadminReq, /* getregionReq, */ chAdPassReq } from '../config/httpRoutes';
import { Row, Form, Col, Card, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faLock, faPlus, faSpinner, faTrashAlt, faUsers } from '@fortawesome/free-solid-svg-icons';
import Loader from '../components/loader';
import TextInput from '../components/textInput';
// import SelectIDInput from '../components/selectIdInput';

class Admins extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			name: '',
			phone: '',
			password: '',
			// region: '',
			admins: null,
			// regions: null,
			errors: { name: '', phone: '', password: ''/* , region: '' */ },
			loading: false,
			deleteLoading: false,
			fetchLoading: true,
			form: false,
			ch: false,
			id: '',
		};
	}

	componentDidMount() {
		this.getAdmins();
		// this.getPreReqs();
	}

	// getPreReqs = async () => {
	// 	try {
	// 		const regions = (await getregionReq()).data;
	// 		this.setState({
	// 			regions
	// 		});
	// 	} catch(err) {
	// 		alertError("Could not fetch required data");
	// 	}
	// }

	getAdmins = () => {
		this.setState({fetchLoading: true});
		getadminReq()
		.then( (res) => {
			this.setState({admins: res.data, form: false, ch: false});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not fetch admins");
		}).finally( () => {
			this.setState({fetchLoading: false});
		});
	}

	rmAdmin = (id, index) => {
		this.setState({deleteLoading: true});
		rmadminReq({id})
		.then( (res) => {
			const { admins } = this.state;
			admins.splice(index, 1);
			this.setState({admins});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not remove admin");
		}).finally( () => {
			this.setState({deleteLoading: false});
		});
	}
	
	handleChange = ({ target: { name, value } }) => {
		if(name === 'phone') {
			this.setState({[name]: ((parseInt(value) || '').toString()).slice(0, 10) || ''});
		} else {
			this.setState({[name]: value});
		}
	}

	validate = () => {
		const { id, name, phone, password/* , region */ } = this.state;
		let errors = { name: '', phone: '', password: ''/* , region: '' */ }, isValid = true;

		if(!name) {
			errors.name = "Enter name to continue";
			isValid = false;
		}
		if(!phone) {
			errors.phone = "Enter phone to continue";
			isValid = false;
		}
		if(!id && !password) {
			errors.password = "Enter password to continue";
			isValid = false;
		}
		// if(!region) {
		// 	errors.region = "Enter region to continue";
		// 	isValid = false;
		// }
		
		this.setState({errors});
		return isValid;
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const { id, name, phone, password/* , region */ } = this.state;
		if(this.validate()) {
			if(id) {
				this.setState({loading: true});
				updadminReq({id, name, phone/* , region */})
				.then( (res) => {
					this.setState({loading: false});
					alertSuccess("Admin updated");
					this.getAdmins();
				}).catch( (err) => {
					this.setState({loading: false});
					alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
				});
			} else {
				this.setState({loading: true});
				addadminReq({name, phone, password/* , region */})
				.then( (res) => {
					this.setState({loading: false});
					alertSuccess("Admin added");
					this.getAdmins();
				}).catch( (err) => {
					this.setState({loading: false});
					alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
				});
			}
		}
	}

	navigateAdd = () => {
		this.setState({ id: '', name: '', password: '', /* region: '', */ errors: {name: '', phone: '', password: ''/* , region: '' */}, loading: false, form: true });
	}

	navigateEdit = (id, name, phone, /* password, */ /* region */) => {
		this.setState({ id, name, phone, /* password, */ /* region, */ errors: {name: '', phone: '', password: ''/* , region: '' */}, loading: false, form: true });
	}

	navigateCh = (id, name) => {
		this.setState({ id, name, password: '', errors: {name: '', phone: '', password: ''/* , region: '' */}, ch: true, loading: false});
	}

	navigateSellers = (id) => {
		this.props.history.push(`/sellers/${id}`);
	}

	validate2 = () => {
		const { /* id, name, phone, */ password, /* region */ } = this.state;
		let errors = { name: '', phone: '', password: ''/* , region: '' */ }, isValid = true;

		if(!password) {
			errors.password = "Enter password to continue";
			isValid = false;
		}
		
		this.setState({errors});
		return isValid;
	}

	submitCh = (e) => {
		e.preventDefault();
		const { id, password } = this.state;
		if(this.validate2()) {
			this.setState({loading: true});
			chAdPassReq({id, password})
			.then( (res) => {
				this.setState({loading: false});
				alertSuccess("Password changed");
				this.getAdmins();
			}).catch( (err) => {
				this.setState({loading: false});
				alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
			});
		}
	}

	render() {
		const { id, name, phone, password, /* region, */ ch, admins, /* regions, */ deleteLoading, errors, loading, fetchLoading, form } = this.state;
		const { handleChange, handleSubmit, navigateAdd, navigateEdit, navigateCh, submitCh, rmAdmin, navigateSellers } = this;
		return (
			ch ?
				<Row style={{marginLeft: 0, marginRight: 0}}>
					<Col md={{span: 4, offset: 4}} lg={{span: 4, offset: 4}} xs={12}>
						<Card style={{marginTop: '20%'}}>
							<Card.Header>
								<Card.Title style={{textAlign: 'center'}}>Change Admin Password</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={submitCh}>
									<Form.Group>
										<TextInput onChange={handleChange} value={password} error={errors.password} name="password" label="Password" type="password" />
									</Form.Group>

									<Button variant="success" type="submit" style={{marginLeft: '30%', width: '40%', marginTop: '25px'}} size="lg" disabled={loading}>
										{loading ?
											<FontAwesomeIcon icon={faSpinner} spin />
										:
											'Save'
										}
									</Button>
								</Form>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			: form ?
				<Row style={{marginLeft: 0, marginRight: 0}}>
					<Col md={{span: 4, offset: 4}} lg={{span: 4, offset: 4}} xs={12}>
						<Card style={{marginTop: '20%'}}>
							<Card.Header>
								<Card.Title style={{textAlign: 'center'}}>{id ? 'Update ' : 'Add '} Admin</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={handleSubmit}>
									<Form.Group>
										<TextInput onChange={handleChange} value={name} error={errors.name} name="name" label="Name" />
									</Form.Group>

									<Form.Group>
										<TextInput onChange={handleChange} value={phone} error={errors.phone} name="phone" label="Phone Number" />
									</Form.Group>

									{id ?
										<></>
									:
										<Form.Group>
											<TextInput onChange={handleChange} value={password} error={errors.password} name="password" label="Password" type="password" />
										</Form.Group>
									}

									{/* <Form.Group>
										<SelectIDInput options={regions} onChange={handleChange} value={region} error={errors.region} name="region" label="Region" />
									</Form.Group> */}

									<Button variant="success" type="submit" style={{marginLeft: '30%', width: '40%', marginTop: '25px'}} size="lg" disabled={loading}>
										{loading ?
											<FontAwesomeIcon icon={faSpinner} spin />
										:
											'Save'
										}
									</Button>
								</Form>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			:
				<Row style={{marginLeft: 0, marginRight: 0, paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%'}}>
					<Col md={12} style={{justifyContent: 'flex-end', display: 'flex', marginTop: '10px', marginBottom: '15px'}}>
						<Button variant="success" onClick={navigateAdd} size="md">
							<FontAwesomeIcon icon={faPlus} /> Add Admin
						</Button>
					</Col>
					{fetchLoading && <Loader />}
					{Array.isArray(admins) ?
						admins.length > 0 ?
							<div className="table-responsive">
								<table className="table table-hover table-attendance">
									<thead>
										<tr>
											<th>Name</th>
											<th>Phone</th>
											{/* <th>Region</th> */}
											<th className="th1">Dependents</th>
											<th className="th1">Action</th>
										</tr>
									</thead>
									<tbody>
										{admins.map(({ id, name, phone, region }, i) =>
											<tr key={i}>
												<td>{name}</td>
												<td>{phone}</td>
												{/* <td>{region?.name}</td> */}
												<td className="text-center">
													<div className="course-control-box icons-container d-flex">
														<OverlayTrigger overlay={<Tooltip>Sellers</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faUsers} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { navigateSellers(id) }} />
														</OverlayTrigger>
													</div>
												</td>
												<td className="text-center">
													<div className="course-control-box icons-container d-flex">
														<OverlayTrigger overlay={<Tooltip>Edit</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faEdit} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { navigateEdit(id, name, phone/* , region */) }} />
														</OverlayTrigger>
														<OverlayTrigger overlay={<Tooltip>Change Password</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faLock} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { navigateCh(id, name) }} />
														</OverlayTrigger>
														<OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
															<FontAwesomeIcon icon={faTrashAlt} className="disabled-icon font-16 cursor-pointer" onClick={(e) => { rmAdmin(id, i) }} />
														</OverlayTrigger>
													</div>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						:
							<p style={{position: 'fixed', marginLeft: '34%', marginTop: '20%'}}>No admins found.</p>
					:
						<></>
					}
				</Row>
		);
	}
}

export default Admins;